import { withInstall } from '@bigin/utils'

import Tag from './src/tag.vue'

export const BTag = withInstall(Tag)
export default BTag

export * from './src/tag'
